class SurveyQuestionModel extends App.Models.BaseModel {
    modelUrl = 'SurveyQuestion';
}

App.Models.SurveyQuestion = SurveyQuestionModel;
